let ProviderName = /*#__PURE__*/function (ProviderName) {
  ProviderName["AMPLITUDE"] = "amplitude";
  ProviderName["BEAMER"] = "beamer";
  ProviderName["GTM"] = "gtm";
  ProviderName["HOTJAR"] = "hotjar";
  return ProviderName;
}({});
class Provider {
  constructor(key, logger, configuration, commonPayload, userId) {
    this.logger = logger;
    this.commonPayload = commonPayload;
    this.userId = userId;
    this.init(key, configuration);
  }
}

export { Provider, ProviderName };
//# sourceMappingURL=Provider.js.map
